import { useTranslation } from "react-i18next";

function useTranslationWithNamespace(namespace: string) {
  const { t } = useTranslation(namespace);
  return { t };
}

export default useTranslationWithNamespace;
